/**
 * Created by fjywan on 16/6/20.
 */
  //此配置主要用于避免或减少数据转换
let Config = {
  //指示子节点的字段名
  fieldOfChildren: 'children',
  //指示节点名的字段
  fieldOfName: 'categoryName',
  //指示节点id的字段
  fieldOfId: 'categoryId'
};


export default Config;



/** WEBPACK FOOTER **
 ** ./src/components/checkboxtree/default.config.js
 **/